import { Select } from "antd";

export default function Shipping(params) {
  return (
    <Select
      className="w-full"
      placeholder="Allow Shipping?"
      allowClear
      showSearch
      filterOption={(input, option) =>
        option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onChange={(v) => params.onChange("allow_shipping", v)}
      options={[
        {
          value: "1",
          label: "Yes",
        },
        {
          value: "0",
          label: "No",
        },
      ]}
    />
  );
}
